import script from "./SmNotify.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmNotify.vue?vue&type=script&lang=ts&setup=true"

import "./SmNotify.vue?vue&type=style&index=0&id=2a6ccf68&lang=scss"

const __exports__ = script;

export default __exports__